// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld/base/core';
import './fieldViewer';

/**
 * Displays a link field value
 * @name LinkFieldViewer
 * @constructor
 * @extends {FieldViewer}
 */
myw.LinkFieldViewer = myw.FieldViewer.extend({
    tagName: 'a',

    render() {
        let fieldValue = this.fieldValue;
        const nully = fieldValue === null || fieldValue === '';
        if (nully) {
            //first check if we should render the value or not
            if (this.options.renderAll) this.$el.html(`<i>${this.msg('no_reference')}`);
            return;
        }

        if (fieldValue.indexOf('|') < 0) fieldValue = `|${fieldValue}`; //allow description to be optional

        const // <description>|<url>
            regexp = /(.*)\|(\w+\:\/\/(.*))/i,
            res = regexp.exec(fieldValue),
            linkDescription = res && (res[1] || res[2]),
            url = res && res[2];

        if (res) {
            this.$el
                .attr('target', '_blank')
                .attr('href', url)
                .html(_.escape(linkDescription));
        } else {
            this.$el.html(this.msg('link_error', { link: _.escape(fieldValue) }));
        }
    }
});

export default myw.LinkFieldViewer;
